export function priorDecisionPeriods(currentPeriod) {
  const period = Number(currentPeriod);
  return Number.isSafeInteger(period) && period > 0 ? Array.from({ length:period }, (_,i)=>i) : [];
}
export function historyBefore(history,currentPeriod) {
  const entries = new Map((history || []).map(entry=>[Number(entry.period),entry]));
  return priorDecisionPeriods(currentPeriod).map(period=>entries.get(period) || {period,products:null});
}
export function historyDragPosition(initial,start,current,maximum) {
  return Math.max(0,Math.min(maximum,initial + start - current));
}
